import React, {Component} from 'react';
import PropTypes from "prop-types";
import Api from "../../utils/Api";
import LoadingSplash from "../../globalComponents/LoadingSplash";
import TreeStructureOverviewContainer from "./TreeStructureOverviewContainer";
import TreeStructureDetailContainer from "./TreeStructureDetailContainer";
import SearchField from "../../utils/SearchField";

class TreeStructureContainer extends Component {

    static propTypes = {
        baseData: PropTypes.object.isRequired,
    };

    constructor(props) {

        super(props);

        this.api = new Api();

        this.state = {
            searchString: null,
            selectedCompany: null,
            treeStructure: null
        };

        this.translate = this.props.baseData.translate;

        this.requestCompanyStructure = this.requestCompanyStructure.bind(this);
        this.onSearch = this.onSearch.bind(this);
        this.onCancel = this.onCancel.bind(this);
        this.selectCompany = this.selectCompany.bind(this);

    }

    componentWillMount() {

        const settings = this.props.baseData.userData.settings ? this.props.baseData.userData.settings : {};
        const state = {...this.state};
/*
        //  Show Details aus den userprops laden
        const selectedCompany = (settings.showTreeDetails) ? JSON.parse(settings.showTreeDetails) : null;

        if (selectedCompany) state.selectedCompany = selectedCompany;
*/
        this.setState(state, this.requestCompanyStructure);

    }

    requestCompanyStructure() {

        const params = {
            action: 'getCompanyStructure',
            userId: this.props.baseData.userData.id,
            currentCompanyId: this.props.baseData.companies.currentCompany.id,
        };

        const callback = function(res) {
            if (res) {
                this.setState({
                    treeStructure: res
                });
            }
        }.bind(this);

        this.api.request('AdminFunctions', params, callback);

    }

    onSearch(name, value) {

        this.setState({
            searchString: value
        });

    }

    onCancel() {

        //console.debug('onCancel');

    }

    selectCompany(company) {

        let selected = null;

        if (company !== null && (this.state.selectedCompany === null || this.state.selectedCompany.id !== company.id)) {
            selected = company;
        }

        this.props.baseData.saveSettings('showTreeDetails', JSON.stringify(company));

        this.setState({
            selectedCompany: selected
        });

    }

    render() {

        if (this.state.treeStructure === null) return <LoadingSplash color={'dark'}/>;

        const selectedCompanyId = (this.state.selectedCompany) ? this.state.selectedCompany.id : null;
        const widthStructure = (this.state.selectedCompany) ? 'treeScrollBox ma-bo-20 col-xs-8' : 'col-xs-12';
        const widthDetails = (this.state.selectedCompany) ? 'col-xs-4' : 'col-xs-0';

        return (
            <div>
                <div className="ma-bo-10 clearfix">
                    <div className="clearfix">
                        <nav>
                            <h1>{this.translate('treeStructure')} ({this.translate('superadminOnly')})</h1>

                            <SearchField
                                baseData={this.props.baseData}
                                name="searchCompanyOverview"
                                placeholder={this.translate('searching')}
                                styles={{padding: 0}}
                                onSearch={this.onSearch}
                                onCancel={this.onCancel}
                            />
                        </nav>
                    </div>
                </div>

                <div className="col-xs-12 clearfix">
                    <div className={widthStructure}>
                        <TreeStructureOverviewContainer
                            baseData={this.props.baseData}
                            treeStructure={this.state.treeStructure}
                            selectedCompanyId={selectedCompanyId}
                            searchString={this.state.searchString}
                            setCompany={this.selectCompany}
                        />
                    </div>

                    <div className={widthDetails}>
                        <TreeStructureDetailContainer
                            baseData={this.props.baseData}
                            companyId={selectedCompanyId}
                            reloadStructure={this.requestCompanyStructure}
                            resetCompany={this.selectCompany}
                        />
                    </div>
                </div>

                <div className="bottomLinks clearfix">
                    <a className="prewLink" onClick={() => this.props.baseData.pageNavigation('admin')}>{this.translate('backToOverview')}</a>
                </div>
            </div>
        );

    }

}

export default TreeStructureContainer;